import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMomentumSpikesDrop = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M24.6606 36.7791C25.2488 37.177 26.0481 37.0227 26.4459 36.4346L32.9294 26.8503C33.3273 26.2621 33.173 25.4628 32.5849 25.065C31.9968 24.6671 31.1975 24.8214 30.7996 25.4095L26.0553 32.4228L21.4054 8.32808C21.3174 7.87201 20.9902 7.49887 20.5496 7.35198L7.69262 3.06633C7.01899 2.84179 6.29087 3.20584 6.06633 3.87947C5.84178 4.5531 6.20584 5.28123 6.87947 5.50577L19.0231 9.55364L23.5305 32.9101L16.5171 28.1658C15.929 27.7679 15.1297 27.9222 14.7318 28.5103C14.334 29.0984 14.4882 29.8977 15.0764 30.2956L24.6606 36.7791Z"
	})
});
export default SvgMomentumSpikesDrop;
